import React from 'react'
import { Tag } from 'antd'
import PropTypes from 'prop-types'
import _ from 'lodash'
import styles from './styles'

const COLOUR = 'purple'

const Organisations = ({ organisations }) => {
  const PL = _.find(organisations, ['name', 'Premier League'])
  const EFL = _.find(organisations, ['name', 'EFL'])
  if (PL) {
    return (<div className={styles.tag_wrapper}>
      <Tag
        className={styles.tag}
        color={COLOUR}
        key={PL.uuid}
      >
        {PL.name.toUpperCase()}
      </Tag>
    </div>)
  } else if (EFL) {
    return (<div className={styles.tag_wrapper}>
      <Tag
        className={styles.tag}
        color={COLOUR}
        key={EFL.uuid}
      >
        {EFL.name.toUpperCase()}
      </Tag>
    </div>)
  } else {
    return (
      <div className={styles.tag_wrapper}>
        {organisations.map(({ name, uuid }) => {
          return uuid &&
          <Tag
            className={styles.tag}
            color={COLOUR}
            key={uuid}
          >
            {name.toUpperCase()}
          </Tag>
        })}
      </div>
    )
  }
}

Organisations.propTypes = {
  organisations: PropTypes.array
}

export default Organisations
